import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef, useContext } from 'react';
import { GRID_ITEM_CLASS_PREFIX, gridItemRoot } from './constants';
import { useGridItemClassName } from './utils/useGridItemClassName';
import { GridContext } from '../utils/GridContext';
import { GridItemRoot } from './style';
import { useComponentTheme } from '../../../utils/hooks';
import { gridItemTheme } from './theme';
export var GridItem = forwardRef(function GridItem(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(GRID_ITEM_CLASS_PREFIX, gridItemTheme);

  var _useContext = useContext(GridContext),
      gutterSpacing = _useContext.gutterSpacing,
      gutterSpacingVertical = _useContext.gutterSpacingVertical,
      gutterSpacingHorizontal = _useContext.gutterSpacingHorizontal;

  var classOverride = useGridItemClassName(GRID_ITEM_CLASS_PREFIX, className, gutterSpacing);
  return React.createElement(GridItemRoot, Object.assign({
    "data-testid": gridItemRoot
  }, restProps, {
    className: classOverride.Root,
    ref: ref,
    theme: theme,
    gutterSpacing: gutterSpacing,
    gutterSpacingVertical: gutterSpacingVertical,
    gutterSpacingHorizontal: gutterSpacingHorizontal
  }));
});
GridItem.defaultProps = {};